var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var YouTubeIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 52,
    glyphHeight: 37
  }), React.createElement("path", {
    d: "M50.9167 5.6453C50.375 3.47863 48.5333 1.63696 46.3667 1.0953C42.25 0.0119629 26 0.0119629 26 0.0119629C26 0.0119629 9.75 0.0119629 5.63333 1.0953C3.46667 1.7453 1.625 3.47863 1.08333 5.75363C0 9.65363 0 18.1036 0 18.1036C0 18.1036 0 26.5536 1.08333 30.562C1.73333 32.7286 3.46667 34.5703 5.63333 35.112C9.75 36.1953 26 36.1953 26 36.1953C26 36.1953 42.25 36.1953 46.3667 35.112C48.5333 34.462 50.375 32.7286 50.9167 30.562C52 26.5536 52 18.1036 52 18.1036C52 18.1036 52 9.65363 50.9167 5.6453ZM20.8 25.9036V10.3036L34.3417 18.1036L20.8 25.9036Z"
  }));
};
export var YouTubeIconGlyph = function (props) {
  return React.createElement(YouTubeIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};